// src/components/home/StatsCard.js
import React from 'react';

const StatsCard = ({ icon: Icon, label, value, gradient, bgGradient, borderColor, textColor, onClick }) => {
    return (
        <div
            onClick={onClick}
            className={`bg-gradient-to-br ${bgGradient} rounded-2xl px-3 py-4 shadow-sm border ${borderColor} active:scale-95 transition cursor-pointer`}
        >
            <div className={`w-12 h-12 bg-gradient-to-br ${gradient} rounded-2xl flex items-center justify-center mb-3 shadow-md`}>
                <Icon className="w-6 h-6 text-white" />
            </div>
            <p className={`text-xs ${textColor} mb-1 font-medium break-words`}>{label}</p>
            <p className="xs:text-lg text-xl font-bold text-gray-800">{value}</p>
        </div>
    );
};

export default StatsCard;